import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/game/clouds-index.png';
import _imports_1 from '@/assets/images/game/index1.png';
import _imports_2 from '@/assets/images/game/star.png';
import _imports_3 from '@/assets/images/game/index2.png';
import _imports_4 from '@/assets/images/game/index5.png';
import _imports_5 from '@/assets/images/game/index3.png';
import _imports_6 from '@/assets/images/game/index4.png';
const _withScopeId = n => (_pushScopeId("data-v-30af97ad"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "clouds",
  src: _imports_0,
  alt: "clouds",
  draggable: "false"
}, null, -1));
const _hoisted_3 = {
  class: "region"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "model",
  src: _imports_1,
  alt: "index",
  draggable: "false"
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "model-name"
}, "字元港", -1));
const _hoisted_6 = {
  class: "star-progress"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "star",
  src: _imports_2,
  alt: "star",
  draggable: "false"
}, null, -1));
const _hoisted_8 = {
  class: "progress-bar-container"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "model",
  src: _imports_3,
  alt: "index",
  draggable: "false"
}, null, -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "model-name"
}, "声波林", -1));
const _hoisted_11 = {
  class: "star-progress"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "star",
  src: _imports_2,
  alt: "star",
  draggable: "false"
}, null, -1));
const _hoisted_13 = {
  class: "progress-bar-container"
};
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "middle"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "UrbanWorkshop",
  draggable: "false"
}), /*#__PURE__*/_createElementVNode("div", {
  class: "model-name"
}, "城市工坊")], -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "model",
  src: _imports_5,
  alt: "index",
  draggable: "false"
}, null, -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "model-name"
}, "像素岛", -1));
const _hoisted_17 = {
  class: "star-progress"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "star",
  src: _imports_2,
  alt: "star",
  draggable: "false"
}, null, -1));
const _hoisted_19 = {
  class: "progress-bar-container"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "model",
  src: _imports_6,
  alt: "index",
  draggable: "false"
}, null, -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "model-name"
}, "帧序池", -1));
const _hoisted_22 = {
  class: "star-progress"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "star",
  src: _imports_2,
  alt: "star",
  draggable: "false"
}, null, -1));
const _hoisted_24 = {
  class: "progress-bar-container"
};
import { onMounted, ref, watch } from 'vue';
export default {
  __name: 'principalSheet',
  props: {
    handleSheetClick: Function,
    levelChange: {
      default: Number
    },
    setGoldCoin: Function
  },
  setup(__props) {
    const props = __props;
    const num = ref([{
      current: 1,
      allTold: 12
    }, {
      current: 1,
      allTold: 12
    }, {
      current: 1,
      allTold: 12
    }, {
      current: 1,
      allTold: 12
    }]);
    const levelList = ref([
    // 字元港
    {
      level: ['字幕翻译', '图书查找', '市场调查', '聊天机器人', '网页翻译', '搜索推荐', '翻译笔', '成绩查找', '精选评论', '新闻分析', '搜索引擎', '智能客服'],
      approve: [false, false, false, false, false, false, false, false, false, false, false, false],
      current: 0,
      allTold: 11
    },
    // 声波林
    {
      level: ['有声故事书', '会议记录', '语音翻译', '智能语音<br/>玩具', '多人语音<br/>通话', '智能音箱', '声音去噪', '导购机器人', '语音查询', '餐厅叫号', '音频剪辑', '语音导航'],
      approve: [false, false, false, false, false, false, false, false, false, false, false, false],
      current: 0,
      allTold: 11
    },
    // 像素岛
    {
      level: ['智能垃圾桶', '百度搜图', '作品版权<br/>保护', '相册<br/>图片管理', '图片审核', 'AI<br/>绘画创作', '智能相机', '虚拟试衣', '人脸支付', '淘宝<br/>购物拍照', '人脸门禁', '图片特效'],
      approve: [false, false, false, false, false, false, false, false, false, false, false, false],
      current: 0,
      allTold: 11
    },
    // 帧序池
    {
      level: ['监控查询', '视频<br/>精彩集锦', '无人机侦察', '视频分区', '动漫分类', '视频封面', '教程搜索', '自动驾驶<br/>路线规划', '视频<br/>广告推荐', '在线<br/>课堂分类', '可疑人员<br/>追踪', '课堂重点<br/>回放'],
      approve: [false, false, false, false, false, false, false, false, false, false, false, false],
      current: 0,
      allTold: 11
    }]);
    const subjectList = ref([[{
      index: ['字幕翻译', '网页翻译', '翻译笔'],
      title: '是机器翻译的一种应用。',
      expound: '机器翻译主要研究将一种语言的文字自动转换为另一种语言的文字。输入数据由某种语言的一系列符号组成，计算机将其转换为另一种语言的一系列符号。',
      answerList: [{
        name: '循环神经网络',
        imgFrontRes: 3
      }, {
        name: '长短期记忆网络',
        imgFrontRes: 4
      }, {
        name: '隐马尔科夫模型',
        imgFrontRes: 11
      }]
    }, {
      index: ['精选评论', '市场调查', '新闻分析'],
      title: '是情感分析的一种应用。',
      expound: '情感分析是指计算分析人们在文字、语音等信息中的观点，并提取他们的态度和观点。分为二分类和多分类问题：二分类将文本分为好和不好；多分类则将数据分为更详细的类别。',
      answerList: [{
        name: '逻辑回归',
        imgFrontRes: 8
      }, {
        name: '词袋模型',
        imgFrontRes: 15
      }, {
        name: '支持向量机',
        imgFrontRes: 6
      }, {
        name: '循环神经网络',
        imgFrontRes: 3
      }, {
        name: 'K最近邻分类',
        imgFrontRes: 7
      }, {
        name: '长短期记忆网络',
        imgFrontRes: 4
      }]
    }, {
      index: ['图书查找', '搜索推荐', '成绩查找'],
      title: '是文本检索的一种应用。',
      expound: '文本检索是指计算机中存在一个文本数据库，用户通过一个关键词来搜索信息。计算机对文本内容进行分析，快速找到特定关键词或句子然后返回相关结果给用户。',
      answerList: [{
        name: '词袋模型',
        imgFrontRes: 15
      }, {
        name: '倒排索引',
        imgFrontRes: 16
      }, {
        name: '协同过滤',
        imgFrontRes: 13
      }, {
        name: '最近邻搜索',
        imgFrontRes: 14
      }, {
        name: '支持向量机',
        imgFrontRes: 6
      }]
    }, {
      index: ['搜索引擎', '聊天机器人', '智能客服'],
      title: '是意图识别的一种应用。',
      expound: '意图识别是指计算机通过分类确定用户想要表达的意图或目的。例如，当用户输入一段文本时，意图识别可以识别出它是哪个领域的问题，从而给用户提供最相关的信息。',
      answerList: [{
        name: '词袋模型',
        imgFrontRes: 15
      }, {
        name: '逻辑回归',
        imgFrontRes: 8
      }, {
        name: '循环神经网络',
        imgFrontRes: 3
      }, {
        name: '长短期记忆网络',
        imgFrontRes: 4
      }, {
        name: '支持向量机',
        imgFrontRes: 6
      }]
    }], [{
      index: ['有声故事书', '餐厅叫号', '智能语音玩具'],
      title: '是语音合成的一种应用。',
      expound: '语音合成是计算机从文本数据中学习到人类的语音表达模式，然后将一段文字转换为对应的语音。',
      answerList: [{
        name: '循环神经网络',
        imgFrontRes: 3
      }, {
        name: '长短期记忆网络',
        imgFrontRes: 4
      }, {
        name: '生成式对抗网络',
        imgFrontRes: 9
      }, {
        name: '变分自动编码器',
        imgFrontRes: 12
      }, {
        name: '循环生成对抗网络',
        imgFrontRes: 10
      }]
    }, {
      index: ['智能音箱', '语音翻译', '会议记录'],
      title: '是语音识别的一种应用。',
      expound: '语音识别的目标是将语音中的词汇转换为计算机可处理的数据，让计算机理解人类发出的语音指令，将语音从声音转换为文本。',
      answerList: [{
        name: '支持向量机',
        imgFrontRes: 6
      }, {
        name: '循环神经网络',
        imgFrontRes: 3
      }, {
        name: '隐马尔科夫模型',
        imgFrontRes: 11
      }, {
        name: '长短期记忆网络',
        imgFrontRes: 4
      }]
    }, {
      index: ['语音导航', '导购机器人', '语音查询'],
      title: '是语音搜索的一种应用。',
      expound: '语音搜索指人使用语音和搜索引擎互动。将用户的语音输入转换为文本，并基于文本进行搜索与匹配，为用户提供相关结果。',
      answerList: [{
        name: '协同过滤',
        imgFrontRes: 13
      }, {
        name: '最近邻搜索',
        imgFrontRes: 14
      }, {
        name: '循环神经网络',
        imgFrontRes: 3
      }, {
        name: '隐马尔科夫模型',
        imgFrontRes: 11
      }, {
        name: '长短期记忆网络',
        imgFrontRes: 4
      }]
    }, {
      index: ['音频剪辑', '多人语音通话', '声音去噪'],
      title: '是语音分离的一种应用。',
      expound: '语音分离分离就是在一个有多个说话人同时说话的场景里，把不同说话人的声音分出来。任务可分为三类：“语音增强”、“多说话人分离”、“解混响”。',
      answerList: [{
        name: '支持向量机',
        imgFrontRes: 6
      }, {
        name: '循环神经网络',
        imgFrontRes: 3
      }, {
        name: '长短期记忆网络',
        imgFrontRes: 4
      }, {
        name: '生成式对抗网络',
        imgFrontRes: 9
      }]
    }], [{
      index: ['AI绘画创作', '图片特效', '虚拟试衣'],
      title: '是图像生成的一种应用。',
      expound: '图像生成是指计算机根据文本、图像等数据生成新的图像。根据目的和输入内容的不同，图像生成主要包括：Ⅰ图像合成 Ⅱ根据现有的图片生成新图像 Ⅲ根据文本生成图像。',
      answerList: [{
        name: '变分自动编码器',
        imgFrontRes: 12
      }, {
        name: '循环生成对抗网络',
        imgFrontRes: 10
      }, {
        name: '生成式对抗网络',
        imgFrontRes: 9
      }]
    }, {
      index: ['人脸支付', '人脸门禁', '智能相机'],
      title: '是目标检测一种应用。',
      expound: '目标检测是指计算机基于图像目标的几何和统计特征来分析图像，帮助人们找出想找的物体。通过目标检测，可以知道物体是什么，以及它们在图像中的位置。',
      answerList: [{
        name: '支持向量机',
        imgFrontRes: 6
      }, {
        name: '卷积神经网络',
        imgFrontRes: 1
      }, {
        name: 'Mask R-CNN',
        imgFrontRes: 2
      }, {
        name: '深度残差网络',
        imgFrontRes: 5
      }]
    }, {
      index: ['淘宝拍照购物', '作品版权保护', '百度搜图'],
      title: '是图像检索的一种应用。',
      expound: '图像检索是指计算机从图片库中搜索满足条件的图片，包括两种：(1) 利用描述图片内容的文本、作者信息等搜索图片；(2)利用图片的颜色、包含物体等内容搜索图片。',
      answerList: [{
        name: '词袋模型',
        imgFrontRes: 15
      }, {
        name: '协同过滤',
        imgFrontRes: 13
      }, {
        name: '倒排索引',
        imgFrontRes: 16
      }, {
        name: '最近邻搜索',
        imgFrontRes: 14
      }, {
        name: '卷积神经网络',
        imgFrontRes: 1
      }, {
        name: '支持向量机',
        imgFrontRes: 6
      }, {
        name: '深度残差网络',
        imgFrontRes: 5
      }]
    }, {
      index: ['图片审核', '相册图片管理', '智能垃圾桶'],
      title: '是图像分类的一种应用。',
      expound: '图像分类是指计算机把输入图像转化为的不同数字特征，将不同类别的目标区分开来，并输出该图像的类别名称。',
      answerList: [{
        name: 'Mask R-CNN',
        imgFrontRes: 2
      }, {
        name: 'K最近邻分类',
        imgFrontRes: 7
      }, {
        name: '卷积神经网络',
        imgFrontRes: 1
      }, {
        name: '支持向量机',
        imgFrontRes: 6
      }, {
        name: '深度残差网络',
        imgFrontRes: 5
      }]
    }], [{
      index: ['视频精彩集锦', '视频封面', '课堂重点回放'],
      title: '是视频摘要的一种应用。',
      expound: '视频摘要是指计算机提取视频中最有代表性的精彩镜头并去掉视频重复部分。可分为两种：1）第一种是直接提取视频中的关键画面生产新的视频；2）第二种是对视频内容生成概括的版本',
      answerList: [{
        name: '卷积神经网络',
        imgFrontRes: 1
      }, {
        name: '长短期记忆网络',
        imgFrontRes: 4
      }]
    }, {
      index: ['无人机侦察', '可疑人员监控', '自动驾驶路线规划'],
      title: '是视频目标追踪的一种应用。',
      expound: '视频目标追踪是指从视频开始指定一个目标，并在后续视频中持续地跟踪该目标。通过边框来标定目标位置，并估计目标的大小。可以单个目标跟踪和多个目标跟踪。',
      answerList: [{
        name: 'Mask R-CNN',
        imgFrontRes: 2
      }, {
        name: '卷积神经网络',
        imgFrontRes: 1
      }, {
        name: '长短期记忆网络',
        imgFrontRes: 4
      }, {
        name: '深度残差网络',
        imgFrontRes: 5
      }]
    }, {
      index: ['教程搜索', '视频广告推荐', '监控查询'],
      title: '是视频内容检索的一种应用。',
      expound: '视频内容检索是指计算机通过理解视频，提取视频内容特征，搜索视频间相似片段。用户通过输入文本、图片或视频，可以在视频库中快速搜索到与输入内容相似的视频片段。',
      answerList: [{
        name: '倒排索引',
        imgFrontRes: 16
      }, {
        name: '协同过滤',
        imgFrontRes: 13
      }, {
        name: '最近邻搜索',
        imgFrontRes: 14
      }, {
        name: '长短期记忆网络',
        imgFrontRes: 4
      }, {
        name: '深度残差网络',
        imgFrontRes: 5
      }]
    }, {
      index: ['视频分区', '动漫分类', '在线课程分类'],
      title: '是视频分类的一种应用。',
      expound: '视频分类是指用户输入视频图像，计算机预测它们属于预先定义好的分类的概率，并处理相邻视频画面之间的时间关系，准确识别视频中的动作，从而实现对视频内容的准确分类。',
      answerList: [{
        name: '支持向量机',
        imgFrontRes: 6
      }, {
        name: 'K最近邻分类',
        imgFrontRes: 7
      }, {
        name: 'Mask R-CNN',
        imgFrontRes: 2
      }, {
        name: '卷积神经网络',
        imgFrontRes: 1
      }, {
        name: '长短期记忆网络',
        imgFrontRes: 4
      }, {
        name: '深度残差网络',
        imgFrontRes: 5
      }]
    }]]);
    // 答案卡片
    const answerCardList = ref([{
      name: '卷积神经网络',
      imgFrontRes: 1
    }, {
      name: 'Mask R-CNN',
      imgFrontRes: 2
    }, {
      name: '循环神经网络',
      imgFrontRes: 3
    }, {
      name: '长短期记忆网络',
      imgFrontRes: 4
    }, {
      name: '深度残差网络',
      imgFrontRes: 5
    }, {
      name: '支持向量机',
      imgFrontRes: 6
    }, {
      name: 'K最近邻分类',
      imgFrontRes: 7
    }, {
      name: '逻辑回归',
      imgFrontRes: 8
    }, {
      name: '生成式对抗网络',
      imgFrontRes: 9
    }, {
      name: '循环生成对抗网络',
      imgFrontRes: 10
    }, {
      name: '隐马尔科夫模型',
      imgFrontRes: 11
    }, {
      name: '变分自动编码器',
      imgFrontRes: 12
    }, {
      name: '协同过滤',
      imgFrontRes: 13
    }, {
      name: '最近邻搜索',
      imgFrontRes: 14
    }, {
      name: '词袋模型',
      imgFrontRes: 15
    }, {
      name: '倒排索引',
      imgFrontRes: 16
    }]);
    const listWidthNum = ref([2, 2, 2, 2]);
    onMounted(() => {
      storage();
      // if (!getCookie('info')) {
      //   setInfo('info', true)
      //   // 清除
      //   localStorage.removeItem('levelList');
      //   localStorage.removeItem('groupListName');
      //   localStorage.removeItem('levelListIndex');
      //   localStorage.removeItem('goldCoin');
      //   localStorage.removeItem('subjectList');
      //   localStorage.removeItem('answerCardList');
      //   props.setGoldCoin(1)
      //   storage()
      // } else {
      //   props.setGoldCoin()
      //   setInfo('info', true)
      //   storage()
      // }
    });

    function storage() {
      const levelListCopy = JSON.parse(localStorage.getItem('levelList'));
      const subjectListCopy = JSON.parse(localStorage.getItem('subjectList'));
      const answerCardListCopy = JSON.parse(localStorage.getItem('answerCardList'));
      if (levelListCopy && subjectListCopy && answerCardListCopy) {
        levelList.value = levelListCopy;
        subjectList.value = subjectListCopy;
        answerCardList.value = answerCardListCopy;
      } else {
        localStorage.setItem('levelList', JSON.stringify(levelList.value));
        localStorage.setItem('subjectList', JSON.stringify(subjectList.value));
        localStorage.setItem('answerCardList', JSON.stringify(answerCardList.value));
      }
      const list = levelList.value;
      if (list && list.length !== 0) {
        num.value = list.map(i => {
          return {
            current: i.approve.filter(item => item === true).length === 0 ? 1 : i.approve.filter(item => item === true).length,
            allTold: i.allTold + 1
          };
        });
      }
      listWidthNum.value = num.value.map(i => {
        return Number((145 * Math.ceil(i.current / i.allTold * 100) * 0.01).toFixed(2));
      });
    }

    // 设置cookie
    function setCookie(name, value, seconds) {
      seconds = seconds || 0;
      let expires = "";
      if (seconds !== 0) {
        const date = new Date();
        date.setTime(date.getTime() + seconds * 1000);
        expires = "; expires=" + date.toGMTString();
      }
      document.cookie = name + "=" + escape(value) + expires + "; path=/";
    }
    function setInfo(key, value) {
      localStorage.setItem(key, value);
      setCookie(key, value);
    }

    // 取得cookie
    function getCookie(name) {
      const nameEQ = name + "=";
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
          c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
          return unescape(c.substring(nameEQ.length, c.length));
        }
      }
      return false;
    }
    watch(() => props.levelChange, newVal => {
      if (newVal) {
        const list = JSON.parse(localStorage.getItem('levelList'));
        if (list) {
          num.value = list.map(i => {
            return {
              current: i.approve.filter(item => item === true).length === 0 ? 1 : i.approve.filter(item => item === true).length,
              allTold: i.allTold + 1
            };
          });
          listWidthNum.value = num.value.map(i => {
            return Number((145 * Math.ceil(i.current / i.allTold * 100) * 0.01).toFixed(2));
          });
        }
      }
    }, {
      deep: true
    });
    function handleSkip(value) {
      props.handleSheetClick(2, value, undefined);
      // 第几关卡 - levelListIndex
      localStorage.setItem('levelListIndex', value);
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: "model-content",
        onClick: _cache[0] || (_cache[0] = $event => handleSkip(0))
      }, [_hoisted_4, _hoisted_5, _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
        class: _normalizeClass(['progress-bar', listWidthNum.value[0] < 80 ? 'progress-bar-bg' : '']),
        style: _normalizeStyle({
          width: listWidthNum.value[0] + 'px',
          background: '#FF017B',
          borderRight: listWidthNum.value[0] !== 145 ? '2px solid #333333' : 'unset'
        })
      }, [_createElementVNode("span", null, _toDisplayString(num.value[0].current) + "/" + _toDisplayString(num.value[0].allTold), 1)], 6)])])]), _createElementVNode("div", {
        class: "model-content",
        onClick: _cache[1] || (_cache[1] = $event => handleSkip(1))
      }, [_hoisted_9, _hoisted_10, _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
        class: _normalizeClass(['progress-bar', listWidthNum.value[1] < 80 ? 'progress-bar-bg' : '']),
        style: _normalizeStyle({
          width: listWidthNum.value[1] + 'px',
          background: '#29E09D',
          borderRight: listWidthNum.value[1] !== 145 ? '2px solid #333333' : 'unset'
        })
      }, [_createElementVNode("span", null, _toDisplayString(num.value[1].current) + "/" + _toDisplayString(num.value[1].allTold), 1)], 6)])])]), _hoisted_14, _createElementVNode("div", {
        class: "model-content",
        onClick: _cache[2] || (_cache[2] = $event => handleSkip(2))
      }, [_hoisted_15, _hoisted_16, _createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("div", _hoisted_19, [_createElementVNode("div", {
        class: _normalizeClass(['progress-bar', listWidthNum.value[2] < 80 ? 'progress-bar-bg' : '']),
        style: _normalizeStyle({
          width: listWidthNum.value[2] + 'px',
          background: '#FFB600',
          borderRight: listWidthNum.value[2] !== 145 ? '2px solid #333333' : 'unset'
        })
      }, [_createElementVNode("span", null, _toDisplayString(num.value[2].current) + "/" + _toDisplayString(num.value[2].allTold), 1)], 6)])])]), _createElementVNode("div", {
        class: "model-content",
        onClick: _cache[3] || (_cache[3] = $event => handleSkip(3))
      }, [_hoisted_20, _hoisted_21, _createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("div", _hoisted_24, [_createElementVNode("div", {
        class: _normalizeClass(['progress-bar', listWidthNum.value[3] < 80 ? 'progress-bar-bg' : '']),
        style: _normalizeStyle({
          width: listWidthNum.value[3] + 'px',
          background: '#A562FF',
          borderRight: listWidthNum.value[3] !== 145 ? '2px solid #333333' : 'unset'
        })
      }, [_createElementVNode("span", null, _toDisplayString(num.value[3].current) + "/" + _toDisplayString(num.value[3].allTold), 1)], 6)])])])])]);
    };
  }
};